import { useFunctionalityIndicatorsCommand } from "./hooks/useFunctionalityIndicatorsCommand.js";
import Textfield from "../../common/components/Textfiled";
import Button from "../../common/components/Button";

function RegisterMonthlyIndicators() {
  const {
    indicators,
    handleChange,
    createIndicator,
    errors: { errors },
  } = useFunctionalityIndicatorsCommand();

  const handleSubmit = (event) => {
    event.preventDefault();
    createIndicator({ ...indicators, type: "mensual" });
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar indicadores mensuales</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Registro de indicadores mensuales. Selecciona el mes y registra
              los valores consolidados del periodo.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Mes</label>
                <input
                  className={`form-control ${errors.date ? "is-invalid" : ""}`}
                  type="month"
                  value={indicators.date ? indicators.date.substring(0, 7) : ""}
                  onChange={(e) =>
                    handleChange({
                      name: "date",
                      value: `${e.target.value}-01`,
                    })
                  }
                />
                {errors.date && (
                  <div className="invalid-feedback">{errors.date}</div>
                )}
              </div>

              <Textfield
                label="Días de trabajo total de conductores"
                placeholder="Días de trabajo total de conductores"
                type="number"
                name="totalDriverWorkDays"
                value={indicators.totalDriverWorkDays}
                onChange={handleChange}
                error={errors.totalDriverWorkDays}
              />

              <Textfield
                label="Total de viajes de trabajo"
                placeholder="Total de viajes de trabajo"
                type="number"
                name="totalWorkTrips"
                value={indicators.totalWorkTrips}
                onChange={handleChange}
                error={errors.totalWorkTrips}
              />

              <Button type="submit">Registrar</Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterMonthlyIndicators;
